// w7.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W7 = () => {
  return <WW config={pageConfigs.w7} />;
};

export default W7;
